export default __webpack_public_path__ + "static/media/bannerGW.572be756.webp";